import React from 'react'
import { Main, MainBody, MainTop, MainTopLeft, MainTopTitle } from '@/components/Layout'
import Resx from '@/components/Resx'
import RtgsReportsGrid from '@/components/reporting/rtgsReportsGrid'
import { CreateChangeItem } from '@/components/changeRequests/createChangeItem'

export const RtgsReports = React.memo(() => {
  return (
    <Main>
      <MainTop>
        <MainTopTitle>
          <Resx name='Menu.RtgsReports' />
        </MainTopTitle>
        <MainTopLeft>
          <CreateChangeItem buttonText='Reporting.NewRtgsReportItem' scope='Rtgsreports' />
        </MainTopLeft>
      </MainTop>
      <MainBody>
        <RtgsReportsGrid />
      </MainBody>
    </Main>
  )
})



// WEBPACK FOOTER //
// ./src/internal-app/pages/rtgsReports/RtgsReports.js